module.exports = __webpack_public_path__ + "img/gal_7.caf28498.png";